/**
 * VAQT va MIQDORNING ekrandagi ko'rinishi.
 *
 * Bir xil nusxasi to'rt joyda yurgan edi (partiya tarixi, ishlatish
 * ro'yxati, ishlatish kartochkasi va statistika paneli) — ya'ni sana
 * formati bir kun ulardan birida boshqacha bo'lib qolardi. Qoida bitta
 * joyda yashashi kerak.
 *
 * `Intl` ATAYLAB ishlatilmaydi: bu temir yo'l tizimi va sana har uch
 * tilda ham `kun.oy.yil` bo'lib yoziladi — brauzer tiliga ergashish
 * ruscha interfeysda `11.08.2026`, inglizchada `8/11/2026` qilib,
 * bir xil hujjatni ikki xil o'qiydigan qilib qo'yardi.
 */

const pad = (value: number): string => String(value).padStart(2, '0');

/** `2026-08-11T14:40:00.000Z` → `11.08.2026 14:40` (MAHALLIY vaqt). */
export const formatMoment = (iso: string): string => {
  const at = new Date(iso);
  /* Buzuq qiymat XOM holicha qaytadi: «Invalid Date» dan ko'ra
     serverdan kelgan satrning o'zi ko'proq ma'lumot beradi. */
  if (Number.isNaN(at.getTime())) return iso;
  return `${pad(at.getDate())}.${pad(at.getMonth() + 1)}.${at.getFullYear()} ${pad(at.getHours())}:${pad(at.getMinutes())}`;
};

/**
 * Miqdor — uch xonaga yaxlitlangan va mingliklari ajratilgan.
 *
 * Bazada `NUMERIC(14,3)`, ya'ni uch xona ANIQ; kasrning quyrug'i esa
 * `0.5` ni `0.5000000001` qilib ko'rsatadigan suzuvchi nuqta xatosi.
 */
export const formatQty = (qty: number): string =>
  (Math.round(qty * 1000) / 1000).toLocaleString('ru-RU');
